module.exports = __webpack_public_path__ + "static/media/Roboticon02@3x.9dd32bb4.png";